
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Cergy dès 290€/mois – ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Cergy certifiée Google Partner, accompagne les entreprises cergyssoises pour accroître leur notoriété en ligne et générer davantage de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Cergy dès 290€/mois – ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Cergy certifiée Google Partner, accompagne les entreprises cergyssoises pour accroître leur notoriété en ligne et générer davantage de prospects.",
        },
      ],
    };
  },
};
